import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import { TaskDueDateStatus } from '../enums';

@Pipe({ name: 'dueDateStatusFormat' })
export class TaskDueDateLabelFormatPipe implements PipeTransform {
  constructor(private translate: TranslateService, private datePipe: DatePipe) {}

  transform(status: TaskDueDateStatus, date: Date): string {
    return `${this.translate.instant(
      `TASK.${status === TaskDueDateStatus.AHEAD ? (!date ? 'DUE_DATE' : 'DUE') : status}`,
    )}${
      status === TaskDueDateStatus.AHEAD && !!date
        ? ` ${this.datePipe.transform(date, 'yyyy-MM-dd hh:mm')}`
        : ''
    }`;
  }
}
